<soft-page>
  <soft-page-header [customClass]="'!p-0'">
    <div class="w-full mb-4">
      <soft-default-header
        [title]="steps[1].header | translate"
        [subtitle]="steps[1].subHeader | translate"
      />
      <soft-ds-progress-steps class="mx-2" [steps]="steps" [currentIndex]="1" />
    </div>
  </soft-page-header>

  <soft-page-panel panelStyle="plain" clip class="overflow-hidden">
    <soft-page-panel-header>
      <soft-ds-search-input class="pt-2 mt-1" size="lg" placeholder="Artikel suchen..." (valueChange)="searchValue$.next($event)"></soft-ds-search-input>
    </soft-page-panel-header>

    <div class="soft-overline mt-4">
      {{'#LAGERKORREKTUR_ARTIKEL.PAGES.ARTIKEL_AUSWAHL.ARTIKEL' | translate}}
    </div>
    <soft-artikel-menge-auswahl class="overflow-y-auto"
      [lagerplatzInhalt]="filteredStorageLocationData()"
      (artikelMengeChange)="onSelect($event)"
    />
  </soft-page-panel>

</soft-page>
